
export const qb = [
  {
    useranswer:"",
    serial: "0",
    q: "What is the output of print(2 ** 3)?",
    op1: "8",
    op2: "6",
    op3: "9",
    op4: "7",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "1",
    q: "Which of the following is the correct extension for Python files?",
    op1: ".pt",
    op2: ".py",
    op3: ".pyt",
    op4: ".p",
    ans: "2",
  },
  {
    useranswer:"",
    serial: "2",
    q: "What is the correct syntax to output the type of a variable or object in Python?",
    op1: "print(typeof(x))",
    op2: "print(typeOf(x))",
    op3: "print(type(x))",
    op4: "print(types(x))",
    ans: "3"
  },
  {
    useranswer:"",
    serial: "3",
    q: "Which of the following is a mutable data type in Python?",
    op1: "str",
    op2: "tuple",
    op3: "list",
    op4: "int",
    ans: "3"
  },
  {
    useranswer:"",
    serial: "4",
    q: "How do you insert COMMENTS in Python code?",
    op1: "# This is a comment",
    op2: "// This is a comment",
    op3: "/* This is a comment */",
    op4: "<!-- This is a comment -->",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "5",
    q: "Which of the following functions can be used to read input from the user in Python?",
    op1: "get()",
    op2: "input()",
    op3: "read()",
    op4: "scan()",
    ans: "2"
  },
  {
    useranswer:"",
    serial: "6",
    q: "What will be the output of the following code?\nprint('Hello' * 3)",
    op1: "HelloHelloHello",
    op2: "Hello 3",
    op3: "Hello, Hello, Hello",
    op4: "Error",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "7",
    q: "Which of the following statements is used to create a function in Python?",
    op1: "function myFunction():",
    op2: "def myFunction():",
    op3: "create myFunction():",
    op4: "fun myFunction():",
    ans: "2"
  },
  {
    useranswer:"",
    serial: "8",
    q: "What is the correct syntax for a for loop in Python?",
    op1: "for i in range(5):",
    op2: "for(i=0; i<5; i++)",
    op3: "for i to 5",
    op4: "foreach (i in range(5))",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "9",
    q: "How do you create a dictionary in Python?",
    op1: "dict = {'name':'John', 'age':25}",
    op2: "dict = 'name' => 'John', 'age' => 25",
    op3: "dict = ('name':'John', 'age':25)",
    op4: "dict = {'name'->'John', 'age'->25}",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "10",
    q: "What is the result of the following expression?\n3 + 4 * 2",
    op1: "14",
    op2: "11",
    op3: "10",
    op4: "12",
    ans: "2"
  },
  {
    useranswer:"",
    serial: "11",
    q: "Which keyword is used to create a class in Python?",
    op1: "class",
    op2: "create",
    op3: "define",
    op4: "struct",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "12",
    q: "Which method is used to add an element at the end of a list in Python?",
    op1: "append()",
    op2: "insert()",
    op3: "add()",
    op4: "extend()",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "13",
    q: "What will be the output of the following code?\nprint('Hello, World!'.lower())",
    op1: "HELLO, WORLD!",
    op2: "hello, world!",
    op3: "Hello, World!",
    op4: "hello, WORLD!",
    ans: "2"
  },
  {
    useranswer:"",
    serial: "14",
    q: "How do you start a block of code in Python?",
    op1: "With curly braces {}",
    op2: "With a semicolon ;",
    op3: "With indentation",
    op4: "With parentheses ()",
    ans: "3"
  },
  {
    useranswer:"",
    serial: "15",
    q: "Which of the following operators is used for string concatenation in Python?",
    op1: "*",
    op2: "&",
    op3: "+",
    op4: "%",
    ans: "3"
  },
  {
    useranswer:"",
    serial: "16",
    q: "Which of the following is a Python built-in function?",
    op1: "sqrt()",
    op2: "factorial()",
    op3: "print()",
    op4: "log()",
    ans: "3"
  },
  {
    useranswer:"",
    serial: "17",
    q: "What is the result of the following expression?\nlen([1, 2, 3, 4])",
    op1: "4",
    op2: "5",
    op3: "3",
    op4: "6",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "18",
    q: "Which of the following data types is immutable in Python?",
    op1: "list",
    op2: "dict",
    op3: "set",
    op4: "tuple",
    ans: "4"
  },
  {
    useranswer:"",
    serial: "19",
    q: "What does the following code do?\nlist1 = [1, 2, 3]\nlist2 = list1.copy()",
    op1: "Copies list1 to list2",
    op2: "References list1 to list2",
    op3: "Creates an alias for list1 as list2",
    op4: "Clears list1 and assigns to list2",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "20",
    q: "Which statement is used to stop a loop in Python?",
    op1: "stop",
    op2: "exit",
    op3: "break",
    op4: "terminate",
    ans: "3"
  },
  {
    useranswer:"",
    serial: "21",
    q: "What is the output of the following code?\nprint(type(5.0))",
    op1: "<class 'int'>",
    op2: "<class 'float'>",
    op3: "<class 'double'>",
    op4: "<class 'decimal'>",
    ans: "2"
  },
  {
    useranswer:"",
    serial: "22",
    q: "Which of the following is not a keyword in Python?",
    op1: "with",
    op2: "for",
    op3: "fetch",
    op4: "while",
    ans: "3"
  },
  {
    useranswer:"",
    serial: "23",
    q: "How do you declare a variable in Python?",
    op1: "int x = 5",
    op2: "x := 5",
    op3: "x = 5",
    op4: "declare x = 5",
    ans: "3"
  },
  {
    useranswer:"",
    serial: "24",
    q: "Which of the following functions can be used to get the ASCII value of a character in Python?",
    op1: "ord()",
    op2: "char()",
    op3: "ascii()",
    op4: "ordval()",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "25",
    q: "What is the output of the following code?\nprint('Hello, {}'.format('Alice'))",
    op1: "Hello, {}",
    op2: "Hello, Alice",
    op3: "Hello, {Alice}",
    op4: "Hello, World!",
    ans: "2"
  },
  {
    useranswer:"",
    serial: "26",
    q: "What is the use of the pass statement in Python?",
    op1: "To exit a function",
    op2: "To skip the iteration",
    op3: "To do nothing",
    op4: "To pass control to another function",
    ans: "3"
  },
  {
    useranswer:"",
    serial: "27",
    q: "How do you check if a key exists in a dictionary in Python?",
    op1: "if key in dict:",
    op2: "if key exists dict:",
    op3: "if key includes dict:",
    op4: "if key has dict:",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "28",
    q: "What is the output of the following code?\nprint(bool(0))",
    op1: "True",
    op2: "False",
    op3: "0",
    op4: "1",
    ans: "2"
  },
  {
    useranswer:"",
    serial: "29",
    q: "Which of the following modules in Python is used to generate random numbers?",
    op1: "random",
    op2: "rand",
    op3: "math",
    op4: "number",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "30",
    q: "Which of the following is not a valid Python data type?",
    op1: "list",
    op2: "tuple",
    op3: "array",
    op4: "dict",
    ans: "3"
  },
  {
    useranswer:"",
    serial: "31",
    q: "How do you create a set in Python?",
    op1: "set = {1, 2, 3}",
    op2: "set = [1, 2, 3]",
    op3: "set = (1, 2, 3)",
    op4: "set = <1, 2, 3>",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "32",
    q: "What is the output of the following code?\nprint('5' + '7')",
    op1: "12",
    op2: "57",
    op3: "Error",
    op4: "None of the above",
    ans: "2"
  },
  {
    useranswer:"",
    serial: "33",
    q: "Which keyword is used to handle exceptions in Python?",
    op1: "catch",
    op2: "except",
    op3: "exception",
    op4: "handle",
    ans: "2"
  },
  {
    useranswer:"",
    serial: "34",
    q: "Which of the following is a correct way to create a generator in Python?",
    op1: "def gen(): yield 1",
    op2: "gen = [x for x in range(10)]",
    op3: "gen = (x for x in range(10))",
    op4: "def gen() -> int: yield 1",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "35",
    q: "How do you convert a string to an integer in Python?",
    op1: "int('123')",
    op2: "str(123)",
    op3: "float('123')",
    op4: "chr(123)",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "36",
    q: "Which of the following methods can be used to find the length of a string in Python?",
    op1: "length()",
    op2: "size()",
    op3: "len()",
    op4: "count()",
    ans: "3"
  },
  {
    useranswer:"",
    serial: "37",
    q: "Which method is used to convert an object into a string representation in Python?",
    op1: "__str__()",
    op2: "__repr__()",
    op3: "str()",
    op4: "repr()",
    ans: "4"
  },
  {
    useranswer:"",
    serial: "38",
    q: "What is the output of the following code?\nprint(list(range(3)))",
    op1: "[1, 2, 3]",
    op2: "[0, 1, 2]",
    op3: "[0, 1, 2, 3]",
    op4: "[1, 2, 3, 4]",
    ans: "2"
  },
  {
    useranswer:"",
    serial: "39",
    q: "Which of the following is a built-in module in Python?",
    op1: "os",
    op2: "sys",
    op3: "math",
    op4: "All of the above",
    ans: "4"
  },
  {
    useranswer:"",
    serial: "40",
    q: "How do you check the data type of a variable in Python?",
    op1: "typeOf(x)",
    op2: "typeof(x)",
    op3: "type(x)",
    op4: "datatype(x)",
    ans: "3"
  },
  {
    useranswer:"",
    serial: "41",
    q: "What is the result of the following code?\nx = [1, 2, 3]\nx.append([4, 5])\nprint(len(x))",
    op1: "5",
    op2: "4",
    op3: "3",
    op4: "6",
    ans: "2"
  },
  {
    useranswer:"",
    serial: "42",
    q: "Which of the following can be used to iterate over the keys of a dictionary?",
    op1: "for key in dict.keys():",
    op2: "for key in dict:",
    op3: "for key in dict.values():",
    op4: "Both 1 and 2",
    ans: "4"
  },
  {
    useranswer:"",
    serial: "43",
    q: "Which statement is used to continue to the next iteration of a loop in Python?",
    op1: "break",
    op2: "continue",
    op3: "pass",
    op4: "skip",
    ans: "2"
  },
  {
    useranswer:"",
    serial: "44",
    q: "What is the output of the following code?\nprint(10 // 3)",
    op1: "3.333",
    op2: "3",
    op3: "4",
    op4: "3.0",
    ans: "2"
  },
  {
    useranswer:"",
    serial: "45",
    q: "Which method removes the last item from a list in Python?",
    op1: "remove()",
    op2: "pop()",
    op3: "del()",
    op4: "discard()",
    ans: "2"
  },
  {
    useranswer:"",
    serial: "46",
    q: "How do you create a new empty set in Python?",
    op1: "set = []",
    op2: "set = {}",
    op3: "set = set()",
    op4: "set = ()",
    ans: "3"
  },
  {
    useranswer:"",
    serial: "47",
    q: "What is the output of the following code?\nprint('Python'.replace('P', 'J'))",
    op1: "Python",
    op2: "Jython",
    op3: "JythonPython",
    op4: "J",
    ans: "2"
  },
  {
    useranswer:"",
    serial: "48",
    q: "Which of the following is the correct syntax for defining a class in Python?",
    op1: "class MyClass():",
    op2: "class MyClass:",
    op3: "class MyClass:",
    op4: "class MyClass:",
    ans: "2"
  },
  {
    useranswer:"",
    serial: "49",
    q: "How do you remove an item from a list by index in Python?",
    op1: "list.pop(index)",
    op2: "list.remove(index)",
    op3: "del list[index]",
    op4: "Both 1 and 3",
    ans: "4"
  },
  {
    useranswer:"",
    serial: "50",
    q: "Which of the following is used to read a file in Python?",
    op1: "open()",
    op2: "read()",
    op3: "input()",
    op4: "write()",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "51",
    q: "What is the output of the following code?\nprint('abc'.upper())",
    op1: "ABC",
    op2: "Abc",
    op3: "abc",
    op4: "None of the above",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "52",
    q: "Which of the following statements is true about the Python programming language?",
    op1: "Python is a compiled language.",
    op2: "Python is an interpreted language.",
    op3: "Python is a markup language.",
    op4: "Python is a machine language.",
    ans: "2"
  },
  {
    useranswer:"",
    serial: "53",
    q: "How do you declare a global variable inside a function in Python?",
    op1: "global variableName",
    op2: "var global variableName",
    op3: "global: variableName",
    op4: "variableName = global",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "54",
    q: "Which of the following methods can be used to return an iterator from a list in Python?",
    op1: "iterator()",
    op2: "iter()",
    op3: "next()",
    op4: "list()",
    ans: "2"
  },
  {
    useranswer:"",
    serial: "55",
    q: "What is the result of the following code?\nprint('abc' == 'ABC')",
    op1: "True",
    op2: "False",
    op3: "Error",
    op4: "None of the above",
    ans: "2"
  },
  {
    useranswer:"",
    serial: "56",
    q: "Which of the following is a valid way to declare a variable in Python?",
    op1: "1variable = 'abc'",
    op2: "variable1 = 'abc'",
    op3: "variable-1 = 'abc'",
    op4: "None of the above",
    ans: "2"
  },
  {
    useranswer:"",
    
    serial: "57",
    q: "How do you install a package in Python?",
    op1: "pip install packageName",
    op2: "python install packageName",
    op3: "install packageName",
    op4: "py install packageName",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "58",
    q: "What is the output of the following code?\nprint(3 % 2)",
    op1: "1",
    op2: "2",
    op3: "3",
    op4: "0",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "59",
    q: "Which of the following functions can be used to convert a list to a tuple in Python?",
    op1: "tuple()",
    op2: "list()",
    op3: "convert()",
    op4: "change()",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "60",
    q: "What does the following code do?\nwith open('file.txt', 'r') as f:\n    data = f.read()",
    op1: "Opens file.txt for writing and reads its contents",
    op2: "Opens file.txt for reading and writes its contents",
    op3: "Opens file.txt for reading and reads its contents",
    op4: "Opens file.txt for writing and writes its contents",
    ans: "3"
  },
  {
    useranswer:"",
    serial: "61",
    q: "Which of the following is a valid function definition in Python?",
    op1: "def functionName{}",
    op2: "function functionName()",
    op3: "def functionName():",
    op4: "functionName = function()",
    ans: "3"
  },
  {
    useranswer:"",
    serial: "62",
    q: "How do you handle missing values in a data frame using pandas?",
    op1: "df.dropna()",
    op2: "df.fillna()",
    op3: "df.replace()",
    op4: "Both 1 and 2",
    ans: "4"
  },
  {
    useranswer:"",
    serial: "63",
    q: "What is the output of the following code?\nprint('Python'[1])",
    op1: "P",
    op2: "y",
    op3: "t",
    op4: "h",
    ans: "2"
  },
  {
    useranswer:"",
    serial: "64",
    q: "Which of the following methods can be used to get the current date and time in Python?",
    op1: "datetime.now()",
    op2: "date.now()",
    op3: "time.now()",
    op4: "currentTime()",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "65",
    q: "Which of the following is used to create a new thread in Python?",
    op1: "threading.Thread()",
    op2: "new Thread()",
    op3: "Thread()",
    op4: "thread()",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "66",
    q: "How do you comment multiple lines in Python?",
    op1: "# This is a comment\n# This is another comment",
    op2: "/* This is a comment\nThis is another comment */",
    op3: "// This is a comment\n// This is another comment",
    op4: "Both 1 and 2",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "67",
    q: "Which method is used to remove whitespace from the beginning and end of a string in Python?",
    op1: "strip()",
    op2: "trim()",
    op3: "remove()",
    op4: "delete()",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "68",
    q: "What is the result of the following code?\nprint(10 > 9)",
    op1: "True",
    op2: "False",
    op3: "Error",
    op4: "None of the above",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "69",
    q: "How do you raise a number to a power in Python?",
    op1: "x^y",
    op2: "x**y",
    op3: "pow(x, y)",
    op4: "Both 2 and 3",
    ans: "4"
  },
  {
    useranswer:"",
    serial: "70",
    q: "Which of the following is used to create an infinite loop in Python?",
    op1: "for i in range(inf):",
    op2: "while True:",
    op3: "for(;;)",
    op4: "while(1)",
    ans: "2"
  },
  {
    useranswer:"",
    serial: "71",
    q: "Which of the following can be used to iterate over a sequence of numbers in Python?",
    op1: "range()",
    op2: "xrange()",
    op3: "both range() and xrange()",
    op4: "None of the above",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "72",
    q: "What is the output of the following code?\nprint(type([]))",
    op1: "<class 'list'>",
    op2: "<class 'tuple'>",
    op3: "<class 'dict'>",
    op4: "<class 'set'>",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "73",
    q: "Which of the following is a valid syntax for slicing in Python?",
    op1: "list[start:end]",
    op2: "list[start:end:step]",
    op3: "list[:end]",
    op4: "All of the above",
    ans: "4"
  },
  {
    useranswer:"",
    serial: "74",
    q: "Which of the following can be used to import a module in Python?",
    op1: "import module",
    op2: "import module as alias",
    op3: "from module import *",
    op4: "All of the above",
    ans: "4"
  },
  {
    useranswer:"",
    serial: "75",
    q: "How do you check the version of Python you are using?",
    op1: "python --version",
    op2: "python -v",
    op3: "python --v",
    op4: "python -version",
    ans: "1"
  },
  {
    useranswer:"",
    serial: "76",
    q: "Which of the following is a mutable data type in Python?",
    op1: "str",
    op2: "list",
    op3: "tuple",
    op4: "int",
    ans: "2"
  },
  {
    useranswer:"",
    serial: "77",
    q: "What is the result of the following code?\nprint(bool(''))",
    op1: "True",
    op2: "False",
    op3: "Error",
    op4: "None of the above",
    ans: "2"
  },
  {
    useranswer:"",
    serial: "78",
    q: "Which of the following is a valid way to create a new instance of a class in Python?",
    op1: "obj = className",
    op2: "obj = className()",
    op3: "obj = new className()",
    op4: "obj = create className()",
    ans: "2"
  },
  {
    useranswer:"",
    serial: "79",
    q: "How do you check if a variable is an instance of a particular class in Python?",
    op1: "isinstance(var, class)",
    op2: "instanceof(var, class)",
    op3: "isInstance(var, class)",
    op4: "type(var) == class",
    ans: "1"
  }
  
]


